/* eslint-disable max-len */
const REVERSE_PROXY_LINK = process.env.NEXT_PUBLIC_REVERSE_PROXY_LINK ?? '';
const placeholder = `${REVERSE_PROXY_LINK}/images/product-placeholder.svg`;

export const stockImages = {
  beverage: placeholder,
  pill: placeholder,
  tincture: placeholder,
  cartridge: placeholder,
  preroll: placeholder,
  flower: placeholder,
  extract: placeholder,
  edible: placeholder,
  topical: placeholder,
  merch: placeholder,
};
